import { api } from '../api'
import { ServiceRFQs } from '@/services/RFQs'
import { ServiceWithRFQID } from '../Service'

export const API_SALES_ORDER = {
  GET: 'SalesOrders/Get',
  GET_DYNAMIC: 'SalesOrders/GetAllDynamic',
  POST: 'SalesOrders/Create',
  PATCH: 'SalesOrders/Patch',
  PUT: 'SalesOrders/Put',
  DELETE: 'SalesOrders/Delete',
  ADD_TO_STOCK: 'SalesOrders/AddToStock',
  UPDATE_STOCK: 'SalesOrders/UpdateStock'
}

class ModuleServiceSalesOrders extends ServiceWithRFQID {
  async closePO ({ id, rfqID }) {
    return ServiceRFQs.closePO({ id: rfqID })
      .then(() => {
        return this.patch({ id: id, poStillOpen: false })
      })
  }
  async addToStock ({ id }) {
    return api
      .post(`${API_SALES_ORDER.ADD_TO_STOCK}/${id}`)
  }
  async updateStock ({ id }) {
    return api
      .put(`${API_SALES_ORDER.UPDATE_STOCK}/${id}`)
  }
}
export const ServiceSalesOrders = new ModuleServiceSalesOrders({
  apiGet: API_SALES_ORDER.GET,
  apiGetDynamic: API_SALES_ORDER.GET_DYNAMIC,
  apiPost: API_SALES_ORDER.POST,
  apiPatch: API_SALES_ORDER.PATCH,
  apiPut: API_SALES_ORDER.PUT,
  apiDelete: API_SALES_ORDER.DELETE
})
